import styled from 'styled-components';

export const TimeZonesContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  flex-wrap: wrap;
  height: 100%;
  overflow: hidden;
`;
